import { getCookie } from "../../features/campaign";

export const buildJackrabbitUrl = (baseUrl: string): string => {
  if (typeof window === "undefined") return baseUrl;

  const rybUser = getCookie("rybUser");
  
  if (!rybUser) return baseUrl;

  try {
    const userData = JSON.parse(decodeURIComponent(escape(atob(rybUser))));
    const { email, name, phone } = userData;

    if (!email && !name && !phone) return baseUrl;

    const nameParts = name?.trim().split(/\s+/) || [];
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    const separator = baseUrl.includes("?") ? "&" : "?";
    const params: string[] = [];

    if (firstName) params.push(`MFName=${encodeURIComponent(firstName)}`);
    if (lastName) {
      params.push(`MLName=${encodeURIComponent(lastName)}`);
      params.push(`FamName=${encodeURIComponent(lastName)}`);
    }
    if (email) {
      params.push(`MEmail=${encodeURIComponent(email)}`);
      params.push(`ConfirmMEmail=${encodeURIComponent(email)}`);
    }
    if (phone) params.push(`MCPhone=${encodeURIComponent(phone)}`);

    return `${baseUrl}${separator}${params.join("&")}`;
  } catch (error) {
    console.error("Failed to parse rybUser cookie:", error);
    return baseUrl;
  }
};